import v2026 from '@/sui/data/sheets/edit/spy4/2026'

const result = {
  '2026': v2026.sheet
}

export default result
